export default [
    {
        path: '/prerequisite/part-categories',

        name: 'Part Categories',

        component: () => import('@/views/prerequisite/part-categories'),
    },
];